@app.directive 'matrixCollapsible', ->
  restrict: 'E'
  scope: {}
  controllerAs: 'matrixCollapsible'
  controller: ($scope, $element) ->

    @collapsed = if $(window).width() < 900 then true else false


    @toggleCollapse = ->
      @collapsed = ! @collapsed

    @applyClass = =>
      matrixClass = []
      matrixClass.push "matrix-#{@columns}-col" if @columns
      matrixClass.push "matrix-#{@itemType.toLowerCase()}" if @itemType
      matrixClass.push "matrix-item-numbered" if @showItemNumbers
      matrixClass.join ' '

    @getItemCount = =>
      _.filter(@items, (item) -> item.content.title).length

    this

  bindToController: {
    title: '='
    showItemNumbers: '='
    items: '='
    rows: '='
    columns: '='
    itemType: '='
    theme: '='
    itemTypeOptions: '='
    descriptionCharLimit: '='
  }

  templateUrl: "/assets/templates/components/matrixCollapsible/matrixCollapsible.html"